// extracted by mini-css-extract-plugin
module.exports = {"row":"ProlongationForm_row__J4M1X","form":"ProlongationForm_form__3nIKR","footer":"ProlongationForm_footer__1GEp7","button":"ProlongationForm_button__3yBhA"};